export default __webpack_public_path__ + "static/media/badInfo.956050b2.png";